import { Link, NavLink } from 'react-router-dom';
import { categories } from '@/mocks/navData';
import { getCountByCategory } from '@/utils/nav';

type SidebarProps = {
  mobileOpen: boolean;
  onClose: () => void;
};

const navBase =
  'flex items-center gap-3 rounded-md px-3 py-2.5 text-sm font-medium transition-colors';

function navClass({ isActive }: { isActive: boolean }) {
  return `${navBase} ${
    isActive
      ? 'bg-primary-500 text-background-50'
      : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
  }`;
}

export default function Sidebar({ mobileOpen, onClose }: SidebarProps) {
  return (
    <>
      {mobileOpen && (
        <button
          type="button"
          aria-label="关闭菜单"
          onClick={onClose}
          className="fixed inset-0 z-40 cursor-pointer bg-foreground-950/40 lg:hidden"
        />
      )}

      <aside
        className={`fixed left-0 top-0 z-50 flex h-screen w-[264px] flex-col border-r border-background-200 bg-background-50 transition-transform duration-300 lg:translate-x-0 ${
          mobileOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="flex h-[68px] shrink-0 items-center border-b border-background-200 px-5">
          <Link to="/" className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-compass-3-line text-xl"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-extrabold tracking-tight text-foreground-950">
                蓝导航
              </span>
              <span className="mt-1 text-[10px] tracking-wide text-foreground-500">
                便捷的综合导航平台
              </span>
            </span>
          </Link>
        </div>

        <nav className="flex-1 overflow-y-auto px-3 py-4">
          <NavLink to="/" end className={navClass}>
            <i className="ri-home-5-line text-lg"></i>
            <span className="flex-1">首页</span>
          </NavLink>

          <p className="mb-2 mt-5 px-3 text-xs font-semibold uppercase tracking-wider text-foreground-400">
            导航分类
          </p>
          <div className="flex flex-col gap-1">
            {categories.map((category) => (
              <NavLink
                key={category.slug}
                to={`/category/${category.slug}`}
                className={navClass}
              >
                <i className={`${category.icon} text-lg`}></i>
                <span className="flex-1">{category.label}</span>
                <span className="text-xs text-foreground-400">
                  {getCountByCategory(category.slug)}
                </span>
              </NavLink>
            ))}
          </div>
        </nav>

        <div className="shrink-0 border-t border-background-200 p-3">
          <NavLink to="/about" className={navClass}>
            <i className="ri-information-line text-lg"></i>
            <span className="flex-1">关于我们</span>
          </NavLink>
        </div>
      </aside>
    </>
  );
}